module.exports = __webpack_public_path__ + "static/media/18_A.2c0f20a7.png";